import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsList from '../../../components/newsList';

class RightNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { shopList2 },
        } = this.props;

        return (
            <div className={styles.right_box}>
                <Chip
                    id="255876"
                    type="recommend"
                    title="凰家尚品列表3"
                    groupName="凰家尚品"
                    content={shopList2}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="short" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(RightNewsBox);
